export default {
	loading: false,
	errored: false
};



// WEBPACK FOOTER //
// ./src/reducers/exhibit/exhibitDelete-initialState.js